var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "8" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "table-search",
                      placeholder: "Search Configurations",
                      type: "text"
                    },
                    on: { change: _vm.sanitizeInput },
                    model: {
                      value: _vm.searchField,
                      callback: function($$v) {
                        _vm.searchField = $$v
                      },
                      expression: "searchField"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn ml-3 btn-info",
                      attrs: { variant: "primary" },
                      on: { click: _vm.fetchSearchConfigurations }
                    },
                    [_vm._v("\n          Search\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    directives: [
                      { name: "b-scrollspy", rawName: "v-b-scrollspy" }
                    ],
                    attrs: {
                      outlined: "",
                      striped: "",
                      hover: "",
                      items: _vm.items,
                      "head-variant": "light",
                      fields: _vm.tableFields,
                      filter: _vm.searchField,
                      "show-empty": "",
                      "empty-text": "No Configurations found."
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(configurationId)",
                        fn: function(data) {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "navigation-links",
                                attrs: {
                                  to: {
                                    name: "editConfiguration",
                                    params: {
                                      clientId: data.item.clientId,
                                      id: data.item.configurationId
                                    }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data.item.configurationId) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _c("small", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(data.item.description) +
                                    "\n              "
                                )
                              ])
                            ])
                          ]
                        }
                      },
                      {
                        key: "cell(SK)",
                        fn: function(data) {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "navigation-links",
                                attrs: {
                                  to: {
                                    name: "configuration",
                                    params: { clientId: data.item.SK }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data.item.SK) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }